/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../../../../common";
import type {
  GenericNameServiceLogic,
  GenericNameServiceLogicInterface,
} from "../../../../contracts/dependant/nameService/GenericNameServiceLogic";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "keyName",
        type: "bytes32",
      },
    ],
    name: "getSingle",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "keyName",
        type: "bytes32",
      },
    ],
    name: "getSingleSafe",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "which",
        type: "address",
      },
    ],
    name: "isBlocked",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "keyName",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "which",
        type: "address",
      },
    ],
    name: "isMultiple",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "keyName",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "which",
        type: "address",
      },
    ],
    name: "isMultipleSafe",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "which",
        type: "address",
      },
    ],
    name: "isPrivileged",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address",
      },
    ],
    name: "isTrusted",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "listMultipleEntries",
    outputs: [
      {
        components: [
          {
            internalType: "bytes32",
            name: "name",
            type: "bytes32",
          },
          {
            components: [
              {
                internalType: "address",
                name: "addr",
                type: "address",
              },
              {
                internalType: "bool",
                name: "trusted",
                type: "bool",
              },
            ],
            internalType: "struct GenericNameServiceType.AddressRecord[]",
            name: "records",
            type: "tuple[]",
          },
        ],
        internalType: "struct GenericNameServiceType.MultipleEntryRet[]",
        name: "",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "listSeparatedTrustEntries",
    outputs: [
      {
        components: [
          {
            internalType: "address",
            name: "addr",
            type: "address",
          },
          {
            internalType: "bool",
            name: "trusted",
            type: "bool",
          },
        ],
        internalType: "struct GenericNameServiceType.AddressRecord[]",
        name: "",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "listSingleEntries",
    outputs: [
      {
        components: [
          {
            internalType: "bytes32",
            name: "name",
            type: "bytes32",
          },
          {
            components: [
              {
                internalType: "address",
                name: "addr",
                type: "address",
              },
              {
                internalType: "bool",
                name: "trusted",
                type: "bool",
              },
            ],
            internalType: "struct GenericNameServiceType.AddressRecord",
            name: "record",
            type: "tuple",
          },
        ],
        internalType: "struct GenericNameServiceType.SingleEntryRet[]",
        name: "",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newAssociatedOperator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "flag",
        type: "bool",
      },
    ],
    name: "setAssociatedOperator",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "list",
        type: "address[]",
      },
      {
        internalType: "bool",
        name: "flag",
        type: "bool",
      },
    ],
    name: "setBlockList",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "keyName",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "which",
        type: "address",
      },
      {
        internalType: "bool",
        name: "enable",
        type: "bool",
      },
      {
        internalType: "bool",
        name: "trusted",
        type: "bool",
      },
    ],
    name: "setMultiple",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32[]",
        name: "keyName",
        type: "bytes32[]",
      },
      {
        internalType: "address[]",
        name: "which",
        type: "address[]",
      },
      {
        internalType: "bool[]",
        name: "enable",
        type: "bool[]",
      },
      {
        internalType: "bool[]",
        name: "trusted",
        type: "bool[]",
      },
    ],
    name: "setMultipleEntries",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "list",
        type: "address[]",
      },
      {
        internalType: "bool",
        name: "flag",
        type: "bool",
      },
    ],
    name: "setPrivilegedList",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "which",
        type: "address",
      },
      {
        internalType: "bool",
        name: "enable",
        type: "bool",
      },
      {
        internalType: "bool",
        name: "trusted",
        type: "bool",
      },
    ],
    name: "setSeparatedTrustAddress",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "which",
        type: "address[]",
      },
      {
        internalType: "bool[]",
        name: "enable",
        type: "bool[]",
      },
      {
        internalType: "bool[]",
        name: "trusted",
        type: "bool[]",
      },
    ],
    name: "setSeparatedTrustEntries",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "keyName",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "which",
        type: "address",
      },
      {
        internalType: "bool",
        name: "enable",
        type: "bool",
      },
      {
        internalType: "bool",
        name: "trusted",
        type: "bool",
      },
    ],
    name: "setSingle",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32[]",
        name: "keyName",
        type: "bytes32[]",
      },
      {
        internalType: "address[]",
        name: "which",
        type: "address[]",
      },
      {
        internalType: "bool[]",
        name: "enable",
        type: "bool[]",
      },
      {
        internalType: "bool[]",
        name: "trusted",
        type: "bool[]",
      },
    ],
    name: "setSingleEntries",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
] as const;

const _bytecode =
  "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";

type GenericNameServiceLogicConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: GenericNameServiceLogicConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class GenericNameServiceLogic__factory extends ContractFactory {
  constructor(...args: GenericNameServiceLogicConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<GenericNameServiceLogic> {
    return super.deploy(overrides || {}) as Promise<GenericNameServiceLogic>;
  }
  override getDeployTransaction(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): GenericNameServiceLogic {
    return super.attach(address) as GenericNameServiceLogic;
  }
  override connect(signer: Signer): GenericNameServiceLogic__factory {
    return super.connect(signer) as GenericNameServiceLogic__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): GenericNameServiceLogicInterface {
    return new utils.Interface(_abi) as GenericNameServiceLogicInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): GenericNameServiceLogic {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as GenericNameServiceLogic;
  }
}
